var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeightmeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Bold/weightmeter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 1.83325H7.33333C4.58333 1.83325 2.75 3.66659 2.75 6.41658V15.5833C2.75 18.3333 4.58333 20.1666 7.33333 20.1666H14.6667C17.4167 20.1666 19.25 18.3333 19.25 15.5833V6.41658C19.25 3.66659 17.4167 1.83325 14.6667 1.83325ZM16.1058 7.77325L14.1075 10.9816C14.0525 11.0641 13.9608 11.1283 13.8692 11.1374H13.8233C13.7408 11.1374 13.6583 11.1099 13.5942 11.0549C12.882 10.4217 11.9622 10.0719 11.0092 10.0719C10.0562 10.0719 9.13635 10.4217 8.42417 11.0549C8.38738 11.0879 8.3438 11.1125 8.2965 11.1269C8.2492 11.1412 8.19932 11.145 8.15039 11.1381C8.10145 11.1311 8.05464 11.1134 8.01325 11.0864C7.97186 11.0594 7.9369 11.0236 7.91083 10.9816L5.9125 7.77325C5.8025 7.63575 5.83 7.45242 5.95833 7.33325C7.34704 6.09762 9.14116 5.41499 11 5.41499C12.8588 5.41499 14.653 6.09762 16.0417 7.33325C16.17 7.45242 16.1975 7.63575 16.1058 7.77325Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightmeter);
export default __webpack_public_path__ + "static/media/weightmeter.14ee78838130efbe6ca78596d30bc084.svg";
export { ForwardRef as ReactComponent };